import axios from 'axios';

import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { IStateTitleDocument } from './interfaces';

export const requestCreateStateTitleDocument = async(values: IStateTitleDocument) => {
  try {
    await axios.put(`${SERVICES.DOCUMENT}/state-title-document`, values);
    Notistack.successMessage('State Regulation Configurations - Created Successfully');
  } catch (error) {
    Notistack.generalError(error);
  }
};

export const requestUpdateStateTitleDocument = async(values: IStateTitleDocument) => {
  try {
    await axios.patch(`${SERVICES.DOCUMENT}/state-title-document/${values.id}`, values);
    Notistack.successMessage('State Regulation Configurations - Updated Successfully');
  } catch (error) {
    Notistack.generalError(error);
  }
};

export const requestDeleteStateTitleDocument = async(stateTitleDocumentId: string) => {
  try {
    await axios.delete(`${SERVICES.DOCUMENT}/state-title-document/${stateTitleDocumentId}`);
    Notistack.successMessage('State Regulation Configurations - Deleted Successfully');
  } catch (error) {
    Notistack.generalError(error);
  }
};
